import React from "react";
import POS from "@/pages/POS";

export default function ServicesPOS() {
  return <POS mode="services" />;
}
